import axios from "axios";
import { triggerOfflineFromInterceptor } from "context/NetworkProvider";

export const baseApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Add a request interceptor
baseApi.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    const persistRoot = localStorage.getItem("persist:root");
    let lang = "en";
    if (persistRoot) {
      const parsedPersistRoot = JSON.parse(persistRoot);
      const languageData = JSON.parse(parsedPersistRoot.language);
      const language = languageData.language;
      lang = language || "en";
    }
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.headers["language"] = lang;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
baseApi.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    // Network error — no response from server
    if (!error.response) {
      // Only show offline popup if browser is actually offline
      if (!navigator.onLine) {
        triggerOfflineFromInterceptor();
      }
      return Promise.reject({
        success: false,
        type: "NETWORK_ERROR",
        message: navigator.onLine
          ? "Server unreachable. Please try again."
          : "You are offline. Please check your internet connection.",
      });
    }

    if (error.response.status === 401) {
      // Don't redirect if already on the login page — let the login handler show the error
      const onLoginPage = window.location.pathname === '/' || window.location.pathname === '/login';
      if (!onLoginPage) {
        localStorage.removeItem('token');
        localStorage.removeItem('persist:root');
        window.location.href = '/';
      }
    }

    return Promise.reject(
      error?.response?.data?.message || "Something went wrong"
    );
  }
);
